module.exports = __webpack_public_path__ + "static/IMG-20200905-WA0011-64a80680ce81c1424db4174f275e1029.jpg";